import { useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { ArrowLeft, Mail } from "lucide-react";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email, origin_url: window.location.origin });
      setSent(true);
    } catch (err) {
      toast.error(err.response?.data?.detail || "Erro ao enviar");
    } finally { setLoading(false); }
  };

  return (
    <div data-testid="forgot-page" className="grid-bg min-h-[85vh] flex items-center px-4 py-16">
      <div className="max-w-md mx-auto w-full">
        <Link to="/login" data-testid="forgot-back" className="inline-flex items-center gap-2 text-white/60 hover:text-[#CCFF00] font-manrope text-sm uppercase tracking-widest">
          <ArrowLeft size={16}/> Voltar
        </Link>

        {!sent ? (
          <>
            <span className="sticker mt-6 inline-block">ESQUECEU?</span>
            <h1 className="font-bebas text-6xl mt-6 tracking-tighter">RECUPERAR SENHA</h1>
            <p className="text-white/60 mt-3 font-manrope">Coloca teu email que a gente manda um link pra criar uma nova senha.</p>
            <form onSubmit={submit} className="mt-8 space-y-4">
              <input
                data-testid="forgot-email"
                required
                type="email"
                value={email}
                onChange={(e)=>setEmail(e.target.value)}
                placeholder="Teu email cadastrado"
                className="brutal-input"
              />
              <button data-testid="forgot-submit" disabled={loading} className="brutal-btn w-full">
                {loading ? "Enviando..." : "Enviar link de recuperação"}
              </button>
            </form>
          </>
        ) : (
          <div data-testid="forgot-sent" className="brutal-card brutal-shadow mt-8" style={{borderColor:'#CCFF00'}}>
            <Mail className="text-[#CCFF00]" size={48}/>
            <h2 className="font-bebas text-4xl tracking-tighter mt-4">Confere teu email</h2>
            <p className="text-white/70 mt-3 font-manrope">
              Se esse email tá cadastrado, a gente enviou um link pra criar uma nova senha.
              O link vale por 60 minutos.
            </p>
            <p className="text-white/50 mt-4 font-manrope text-sm">
              Não achou? Olha na caixa de spam ou tenta outro email.
            </p>
            <Link to="/login" data-testid="forgot-to-login" className="brutal-btn w-full mt-6">Voltar pro login</Link>
          </div>
        )}
      </div>
    </div>
  );
}
